import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";

const DictionarySetting = ({
  dictPosi,
  dictNega,
  onChangeDictPosi,
  onChangeDictNega,
  initDict,
}) => {
  const [isDicOpen, setIsDicOpen] = React.useState(false);

  return (
    <Grid item xs={12}>
      <Typography variant="h6" gutterBottom>
        辞書設定
      </Typography>
      <Grid container spacing={4}>
        <Grid item xs={6}>
          <TextField
            id="outlined-multiline-static"
            label="ポジティブキーワード"
            multiline
            minRows={8}
            maxRows={8}
            variant="outlined"
            fullWidth
            value={dictPosi.join("\n")}
            onChange={onChangeDictPosi}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            id="outlined-multiline-static"
            label="ネガティブキーワード"
            multiline
            fullWidth
            minRows={8}
            maxRows={8}
            variant="outlined"
            value={dictNega.join("\n")}
            onChange={onChangeDictNega}
          />
        </Grid>
      </Grid>
      <Grid container justifyContent="flex-end" spacing={4}>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => setIsDicOpen(true)}
          >
            システム辞書で初期化
          </Button>
        </Grid>
      </Grid>
      <Dialog open={isDicOpen} onClose={() => setIsDicOpen(false)}>
        <DialogContent>
          <DialogContentText>初期化してよろしいですか</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            onClick={() => {
              initDict();
              setIsDicOpen(false);
            }}
          >
            はい
          </Button>
          <Button color="primary" onClick={() => setIsDicOpen(false)}>
            いいえ
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default DictionarySetting;
